import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    filters: {
      display: 'flex',
      //marginTop: theme.spacing(2),
      zIndex: 10
    },
    filter: {
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(1)
    },
    filterDisabled: {
      '& > .MuiChip-label': {
        color: '#999 !important'
      }
    }
  })
